/**
 * changement-adresse-accesd
 *
 * Contact: DPSL_UNICODES@desjardins.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Telephones {
  /**
   * Numero de telephone. Format = \'999 999-9999\'
   */
  numeroTelephone: string;
  /**
   * Type de téléphone (Principal, Secondaire ou Employeur)
   */
  typeTelephone: TelephonesTypeTelephoneEnum;
  /**
   * Si un numero de poste est present, format \'9\' a \'999999\' Pour un numero avec extension, le numéro de téléphone est reçu de ClientCIS aucun tiret ni espace avec un maximum de 16 caractères ‘99999999999’ à ‘9999999999999999’ Le numéro de poste est construit en prenant tous les caractères suivant les 10 premiers
   */
  numeroPoste?: string | null;
}
export enum TelephonesTypeTelephoneEnum {
  PRINCIPAL = 'PRINCIPAL',
  SECONDAIRE = 'SECONDAIRE',
  EMPLOYEUR = 'EMPLOYEUR',
}
